// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__3Dg_b"};